// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"39bd52eb","239":"10666422","453":"9c866129","455":"13811005"}[chunkId] + ".chunk.js";
};